import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../services/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from '../../services/alert.service';
import * as html2pdf from 'html2pdf.js';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ToastrManager } from 'ng6-toastr-notifications';



@Component({
  selector: 'app-order-receipt',
  templateUrl: './order-receipt.component.html',
  styleUrls: ['./order-receipt.component.css']
})
export class OrderReceiptComponent implements OnInit {
  apiDomain = `${environment.domain}`;
  html: any = '';
  viewMode: boolean = false;

  showPrint = true;
  showSave = true;
  showActionButtons = true; 
  showEmail = true;
  orderId: any = ''; 
  orderData: any= '';
  constructor(
    private loginService :LoginService,
    private toastr: ToastrManager,
    private http: HttpClient,
    private route: ActivatedRoute,
    private activatedRoute 	: 	ActivatedRoute,
    public alertService: AlertService,
    private router: Router,
  ) {



    this.activatedRoute.params.subscribe((res) => {
      this.orderId = res.orderId;
    });
   }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      console.log('Query params:', params);
      if (params['mode'] === 'view') {
        this.showActionButtons = false;
      }
    });
    this.loginService.getOrderRecepit( this.orderId).subscribe((res: any) => {
        if (res?.status == 'success') {
 
         this.orderData  = res.data;
          
        } else {
          this.router.navigate(['/']);
        }
   
      }
    );
  }

  printSection() {
    this.showActionButtons = false;
    const printContents = document.getElementById('print-section')?.innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents || '';
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); 
  }

  saveAsPDFOld() {
    
    this.showActionButtons = false;

    const element = document.getElementById('print-section');
    if (element) {
      
      const opt = {
        margin:       0,
        filename:     'order-receipt.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
  
      html2pdf().from(element).set(opt).save();
      this.showActionButtons = true;
    }
  }

  saveAsPDF() {
    this.showActionButtons = false;
  
    setTimeout(() => {
      const element = document.getElementById('print-section');
      
      const opt = {
        margin:       0,
        filename:     'order-summary.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
      };
  
      html2pdf().set(opt).from(element).save().then(() => {
        window.location.reload();
       
      });

  
  
    }, 100); 
   
  }

  sendEmailToUser() {
    this.showActionButtons = false;
  
    setTimeout(() => {
      const payload = {
        orderId: this.orderId,
        htmlContent: document.getElementById('print-section')?.innerHTML
      };
  
      this.http.post(this.apiDomain + 'send-email-recipt', payload).subscribe(
        res => {
          this.showActionButtons = true;
          this.toastr.successToastr('Email Sent', 'Success!', { position: 'bottom-right', showCloseButton: true, animate: 'slideFromTop' });
        },
        err => {
          this.showActionButtons = true;
          this.toastr.errorToastr('Error', 'Error!', { position: 'bottom-right', showCloseButton: true, animate: 'slideFromTop' });
        }
      );
    }, 100); 
  }

}
